import { GET_PLC_SAFETY_CAUSES, GET_PLC_SAFETY_CAUSES_SUCCESS, GET_PLC_SAFETY_CAUSES_ERROR } from './actionTypes';

const initialState = {
  errorGetPlcSafetyCauses: '',
  loadingGetPlcSafetyCauses: false,
  causes: null,
};

const getCauses = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLC_SAFETY_CAUSES:
      state = { ...state, loadingGetPlcSafetyCauses: true };
      break;
    case GET_PLC_SAFETY_CAUSES_SUCCESS:
      state = { ...state, loadingGetPlcSafetyCauses: false, causes: action.payload.causes };
      break;
    case GET_PLC_SAFETY_CAUSES_ERROR:
      state = { ...state, errorGetPlcSafetyCauses: action.payload, loadingGetPlcSafetyCauses: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getCauses;
